import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import type { AgentApiJobSourcesIndex, AgentApiJobSourcesItem } from '@/types/serializers';

type Request = {
  query: string;
};

export default function useFetchFlattenJobSources(searchQuery: Request) {
  const query = qs.stringify(searchQuery, { arrayFormat: 'brackets' });
  return useQuery({
    queryKey: ['jobSources', query, 1, ''],
    queryFn: async () => {
      const response = await fetch(`/agent/api/job_sources.json?${query}`);
      const data: AgentApiJobSourcesIndex = await response.json();
      return data.data as AgentApiJobSourcesItem[];
    },
  });
}
